
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { CalcularPMZDTO, CalcularTotaisDTO, Estoque, Estrutura, Relatorio, SelecionarEstruturasDTO } from '../precificacao';
import { PrecificacaoService } from '../precificacao.service';

interface ComboItem {
  name: string,
  code: string
}



@Component({
  selector: 'app-precificacao-criar',
  templateUrl: './precificacao-criar.component.html',
  styleUrls: ['./precificacao-criar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrecificacaoCriarComponent implements OnInit {

  filiaisSelecionadas: any[];
  filiaisCombo: ComboItem[];
  filiais: Estoque[];
  relatorios: Relatorio[];
  relatoriosCombo: ComboItem[];
  relatorioSelecionado: ComboItem;

  estruturas: Estrutura[];
  estrutura: Estrutura={} as Estrutura;

  negocios: ComboItem[];
  negocio: ComboItem;
  departamentos: ComboItem[];
  departamento: ComboItem;
  categorias: ComboItem[];
  categoria: ComboItem;
  segmentos: ComboItem[];
  segmento: ComboItem;
  subSegmentos: ComboItem[];
  subSegmento: ComboItem;
  checkICP: boolean = false;
  checkMCP: boolean = false;
  checkPP: boolean = true;
  percentualA: number = 75;
  percentualB: number = 14;
  percentualC: number = 6;
  selectedCategory: any = null;
  dataInicial:Date;
  dataFinal:Date;
  percentualMax:number=0;




  df: number = 0;
  comissoes: number = 0;
  cf: number = 0;

    categories: any[] = [{name: 'Total Histórico', key: 0}, {name: 'Total Projetado', key: 1}, {name: 'LucroP -((TP-TH)/TP)*LucroP', key: 2}];
    city: string;

  constructor(private precificacaoService:PrecificacaoService,private notificationsService: NotificationsService,private localStorage: LocalStorageService,private router: Router,) { 


  }

  ngOnInit(): void {
    this.selectedCategory = this.categories[1];
    this.filiaisCombo=[];
    this.relatoriosCombo =[];
    this.estruturas =[];
    this.negocios =[];
    this.getFiliais();
    this.getRelatorios();
    this.getEstruturas();

  }

  onDataInicialChange(event){

  }

  onDataFinalChange(event){

  }

  getFiliais(){
    this.precificacaoService.getFiliais().subscribe(
      (res) => {
        if (res) {
          this.filiais = res;    
          this.filiais.forEach((filial) =>{
            let f = {} as ComboItem;
            f.code = filial.cdEstoque;
            f.name = filial.cdEstoque;
            this.filiaisCombo.push(f);
          })   
          
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getRelatorios(){
    this.precificacaoService.getRelatorios().subscribe(
      (res) => {
        if (res) {
          this.relatorios = res;    
          this.relatorios.forEach((filial) =>{
            let f = {} as ComboItem;
            f.code = filial.nomeRelatorio+' - '+filial.descricao;
            f.name = filial.nomeRelatorio;
            this.relatoriosCombo.push(f);
          })   
          
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getEstruturas(){
    this.precificacaoService.getEstruturas().subscribe(
      (res) => {
        if (res) {
          this.estruturas = res;  
          this.estruturas.filter(est => est.nivel==1).forEach((filial) =>{
            let f = {} as ComboItem;
            f.code = filial.idEstrutura.toString();
            f.name = filial.nome;
            this.negocios.push(f);
          })   
          
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  confirmSalvar(){

    if(!this.filiaisSelecionadas){
      this.notificationsService.toastNotify("warn","Alerta!","Selecione uma ou mais filiais para continuar!")
        return;
    }

    console.log(this.filiaisSelecionadas.map(f => f.code).join(',') )
    console.log(this.filiaisSelecionadas);

  }

  setNegocio(evento){
    console.log(evento)
    if(evento.value){
      this.departamentos = this.filterEstruturas(2,evento.value.code) as ComboItem[];
      this.estrutura = this.estruturas.filter(est =>est.idEstrutura == evento.value.code)[0];
    }
  }

  setDepartamento(evento){
    console.log(evento)
    if(evento.value){
      this.categorias = this.filterEstruturas(3,evento.value.code) as ComboItem[];
      this.estrutura = this.estruturas.filter(est =>est.idEstrutura == evento.value.code)[0];
      console.log(this.estrutura)
    }
  }

  setCategoria(evento){
    console.log(evento)
    if(evento.value)
      this.segmentos = this.filterEstruturas(4,evento.value.code) as ComboItem[];
  }

  setSegmento(evento){
    console.log(evento)
    if(evento.value)
      this.subSegmentos = this.filterEstruturas(5,evento.value.code) as ComboItem[];
  }

  filterEstruturas(nivel, pai): ComboItem[]{
    console.log(pai)
    return this.estruturas.filter(est => est.nivel==nivel && est.idEstruturaPai == pai).map(est => ({ code: est.idEstrutura.toString(), name: est.nome  } )) 
  }

  onClickExibirPrecificacao(){
    this.router.navigate([]).then(result => {  window.open('/#/precificacao-analisar', '_blank'); });
  }

  onClickProcessar(){
    
    if(!this.verificarCamposObrigatorios())return;

    let estruturas :SelecionarEstruturasDTO;
    estruturas ={} as SelecionarEstruturasDTO;
    estruturas.estruturas=this.getEstruturasSelecionadas()

    let filtro : CalcularTotaisDTO = {} as CalcularTotaisDTO;
    filtro.filiais=this.filiaisSelecionadas.map(f => f.code).join(',');
    filtro.a = this.percentualA;
    filtro.b = this.percentualA+this.percentualB;
    filtro.c = filtro.b +this.percentualC;
    filtro.dataIni = this.dataInicial;
    filtro.dataFim = this.dataFinal;
    filtro.custo = (this.cf??0)+(this.df??0)+(this.comissoes??0);
    filtro.percMax = this.percentualMax
    filtro.tipoMeta = this.selectedCategory.key;
    filtro.custosSobreCusto = this.checkICP
    filtro.lucroSobreCusto = this.checkMCP
    


    this.precificacaoService.selecionarEstruturas(estruturas).subscribe(
      (res) => {
        this.precificacaoService.calcularTotais(filtro).subscribe(
          (res) => {
            this.localStorage.removeItem("precificacao");
            this.router.navigate([]).then(result => {  window.open('/#/precificacao-analisar', '_blank'); });
          },
          err => {
            this.notificationsService.toastNotify("error","Alerta!","Erro processar!")
            console.log(err);
          }
        );
      },
      err => {
        this.notificationsService.toastNotify("error","Alerta!","Erro ao selecionar Estruturas!")
        console.log(err);
      }
    );
    
  }
  onClickAtingirMeta(){
    this.localStorage.removeItem("precificacao");
  }
  onClickCalcularPMZ(){
    if(!this.verificarCamposObrigatorios())return;
    let filtro:CalcularPMZDTO = {} as CalcularPMZDTO;
    filtro.custo = this.cf??0+this.df??0+this.comissoes??0;
    filtro.relatorio = this.relatorioSelecionado.name;
    filtro.propria = this.checkPP;
    filtro.inativo = false;

    this.precificacaoService.calcularPMZ(filtro).subscribe(
      (res) => {
      },
      err => {
        this.notificationsService.toastNotify("error","Alerta!","Erro processar!")
        console.log(err);
      }
    );
    this.localStorage.removeItem("precificacao");
  }

  getEstruturasSelecionadas(){
    return (this.subSegmento??this.segmento??this.categoria??this.departamento??this.negocio)?.code??"";
  }



  verificarCamposObrigatorios(){



    if(!this.filiaisSelecionadas){
      this.notificationsService.toastNotify("warn","Alerta!","Selecione uma ou mais filiais para continuar!")
        return false;
    }
    if(!this.relatorioSelecionado){
      this.notificationsService.toastNotify("warn","Alerta!","Selecione um relatório para continuar!")
        return false;
    }
    if(!this.getEstruturasSelecionadas()){
      this.notificationsService.toastNotify("warn","Alerta!","Selecione uma ou mais estrutura mercadológica para continuar!")
      return false;
    }
    if(!this.dataInicial || !this.dataFinal){
      this.notificationsService.toastNotify("warn","Alerta!","Selecione uma data de início e fim!")
      return false;
    }

    if(!this.percentualA || !this.percentualB || !this.percentualC){
      this.notificationsService.toastNotify("warn","Alerta!","Informe os percentuais A,B e C para continuar!")
      return false;
    }
    if(((this.df??-1)<0) || ((this.cf??-1)<0) || ((this.comissoes??-1)<0)){
      this.notificationsService.toastNotify("warn","Alerta!","Informe Despesas Fixas, Comissões e Custo Financeiro para continuar!")
      return false;
    }
    if(((this.percentualMax??-1)<0) ){
      this.notificationsService.toastNotify("warn","Alerta!","Informe o percentual Máximo!")
      return false;
    }

    return true;
  }

}
